<template>
<div>
    <div id="container" class="gisDom" :oncontextmenu="doNothing"></div>
    <div id="bimContainer"></div>
</div>
</template>

<script>
import { mapState } from 'vuex'
var gisContext;
var lotPolygonLayer;
var lotTextLayer;
var pipeLineLayer;
var lastFeatureId;
var myInterVar;
const ShpUrl = window.pubilc_config.digitalShpUrl
const CenterPos = [116.41134, 39.51059]
export default {
    name: "GIS",
    props: {
        menubarActive: {
            type: String,
            default: () => {
                return '';
            }
        },
        isShowBim: {
            type: Boolean,
            default: () => {
                return true;
            }
        },
        lotList: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            bimloaded: false
        }
    },
    mounted() {
        window.bim_config = {
            accessToken: 'f57bc9d90c0690ea041195ea99809491',
            localAddress: window.pubilc_config.digitalModelUrl + '/BIMComposer/',
            server: window.pubilc_config.digitalModelApiUrl,
        }
        //开发时临时添加
        if(this.gisScheme) {
            this.render()
        }
    },
    computed: {
        ...mapState("gisData",{
            gisScheme: state => state.gisScheme,
            pipelineColors: state => state.pipelineColors
        })
    },
    watch: {
        //修改地块颜色
        gisScheme(newVal, oldVal) {
            if(oldVal==null) {
                this.render()
            } else {
                this.changeColor() 
            }
        },
        //管线筛选
        pipelineColors(newVal) {
            this.filterPipeline(newVal)
        },
        //bim模型
        isShowBim(val) {
            this.changeBimVisible(val)
        },
        menubarActive(newVal, oldVal) {
            //市政管线
            if(oldVal==='3') {
                this.removePipeline()
            }
            if(newVal==='3') {
                this.addPipeline()
            }
            //地域归属边界线
            if(newVal==='4') {
                this.showLayer('functionText', false)
                this.addRegionLine()
            }
            if(oldVal==='4') {
                this.showLayer('functionText', true)
                this.removeRegionLine()
            }
        },
        bimloaded() {
            //解决层遮挡问题
            gisContext.layerManager.addMapboxTextLayer({ id: 'lotText', shpUrl: ShpUrl+'/功能区.shp', textField: 'BLK',attachFields: ['项目名'], paint:{'text-color':'rgb(0,0,0)'}, layout:{'text-size':12} }, false).then((e)=>{
                lotTextLayer = e;
            })
            gisContext.layerManager.addMapboxPolylineLayer({ id: 'pipelinePolyline', shpUrl: ShpUrl+'/Pipeline.shp', paint: { 'line-color':   [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'rgb(153,204,255)',
                    'rgba(7, 17, 41, 0.5)'
                ] } }, false).then((e)=>{
                pipeLineLayer = e
                this.showLayer('pipelinePolyline', false)
                gisContext.layerManager.addMapboxTextLayer({ id: 'functionText', shpUrl: ShpUrl+'/gongnengqu_point.shp', textField: 'name', paint:{'text-color':'rgb(255,255,255)'}, layout:{'text-size':16} }, false)

                //移动地图位置
                gisContext.map.panBy([-140,-100]);
            });
        }
    },
    methods: {
        doNothing() {
            window.event.returnValue = false;
            return false;
        },
        //隐藏/显示Layer
        showLayer(id, isShow) {
            gisContext.layerManager.setLayerVisible(id, isShow)
        },
        //加载Gis
        render() {
            let _this = this;
            let style = { 
                "version": 8,
                "sources": { "raster-tiles": { "type": "raster", "tiles": ["https://t2.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=1e1e425c920f09544d68abc6d3817d04", "https://t1.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=1e1e425c920f09544d68abc6d3817d04"], "tileSize": 256, "minzoom": 0, "maxzoom": 17 } },
                "sprite": "http://www.probim.cn:8088/BIMComposer/sprite/gisSprite", "glyphs": ShpUrl+'/glyphs.pbf',
                "layers": [{ "id": "tdt-img-tiles", "type": "raster", "source": "raster-tiles" }] 
            };
            gisContext = new window.bim365.GISContext({
                container: 'container',
                style: style,
                center: CenterPos,
                zoom: 12.5,
                pitch: 0,
                bearing: 0
            });
            gisContext.mapCanvasCursor='pointer'

            gisContext.map.on('style.load', () => {

                gisContext.layerManager.addMapboxPolygonLayer({ id: 'lotPolygon', shpUrl: ShpUrl+'/功能区.shp', paint: { 'fill-color': this.gisScheme } }, true).then((e) => {
                    lotPolygonLayer = e;
                    this.changeColor()
                    gisContext.layerManager.addMapboxPolylineLayer({ id: 'lotPolyline', shpUrl: ShpUrl+'/功能区.shp', paint: { 'line-color':   [
                            'case',
                            ['boolean', ['feature-state', 'hover'], false],
                            'rgb(153,204,255)',
                            'rgb(0,0,0)'
                        ] } }, false).then(()=>{}
                    );
                    _this.renderBim()
                })
            });

            //鼠标指针修改
            gisContext.map.on('mousemove', e => {
                let features = gisContext.map.queryRenderedFeatures(e.point, {
                    layers: ['lotPolygon']
                });
                if(features && features.length>0) {
                    gisContext.mapCanvasCursor = 'pointer';
                } else {
                    gisContext.mapCanvasCursor = 'default'
                }
            })

            //以下两个click事件是针对选中效果和返回属性信息的应用示例
            gisContext.map.on('click', 'lotPolygon', e => {
                if (e.features && e.features.length > 0) {
                    if (lastFeatureId >= 0) {
                        lotPolygonLayer.geojson.features[lastFeatureId].properties['BLK'] = lotPolygonLayer.geojson.features[lastFeatureId].properties['BLK'].split('.')[0];
                    }
                    lastFeatureId = e.features[0].properties['uuid'];
                    lotPolygonLayer.geojson.features[e.features[0].properties['uuid']].properties['BLK'] = lotPolygonLayer.geojson.features[e.features[0].properties['uuid']].properties['BLK'] + '.';
                }

                if (e.features) {
                    let features = e.features;
                    features[0].properties['BLK']=features[0].properties['BLK'].split('.')[0];

                    //闪烁feature
                    this.twinkle(features[0].properties['BLK'])

                    //弹信息卡
                    _this.$parent.handleTreeClick({
                        key: features[0].properties['BLK'],
                        lotNumber: features[0].properties['BLK'],
                        label: features[0].properties['项目名']
                    }, true)
                }
            })
        },
        //切换2D/3D默认视角
        setDefaultPoint(is2D) {
            if(is2D) {
                gisContext.map.setPitch(0)
                gisContext.jumpTo({
                    longitude: CenterPos[0],
                    latitude: CenterPos[1],
                    zoom: 13.2
                })
                gisContext.map.panBy([0,130]);
            } else {
                gisContext.map.setPitch(45)
            }
        },
        //根据方案改变颜色
        changeColor() {
            if(!lotPolygonLayer) {
                return;
            }
            let colorinfo = {}
            let alpha = this.menubarActive==='3'? 0.6 : 0.85;
            for(let lotdata of this.lotList) {
                let key = lotdata.lotNumber
                let color = this.gisScheme.colorInfo[key];
                //没有颜色的设置默认色值
                if(!color) {
                    color = '#071129'
                }
                colorinfo[key] = 'rgba(' + parseInt('0x' + color.slice(1, 3)) + ',' + parseInt('0x' + color.slice(3, 5)) + ',' + parseInt('0x' + color.slice(5, 7)) + ',' + alpha + ')';
            }
            let scheme = {
                field: this.gisScheme.field,        
                colorInfo: colorinfo
            }
            // console.log(JSON.stringify(scheme))
            lotPolygonLayer.changeColorByScheme(scheme);
            gisContext.map.getSource(lotPolygonLayer.source).setData(lotPolygonLayer.geojson);
        },
        //选中地块
        doClickLot(lotNumber) {
            let features = lotPolygonLayer.geojson.features;
            let feature = features.find( item => item.properties['BLK'] === lotNumber);
            if(feature) {
                if (lastFeatureId >= 0) {
                    lotPolygonLayer.geojson.features[lastFeatureId].properties['BLK'] = lotPolygonLayer.geojson.features[lastFeatureId].properties['BLK'].split('.')[0];
                }
                lastFeatureId = feature.properties['uuid'];
                this.focusLot();
                this.twinkle(lotNumber);
            }
        },
        //聚焦地块
        focusLot() {
            let bbbox = gisContext.turf.bbox(lotPolygonLayer.geojson.features[lastFeatureId])
            gisContext.map.fitBounds(bbbox,{offset:[100,0],maxZoom:15})
        },
        //根据属性闪烁地块
        twinkle(lotNumber) {
            clearInterval(myInterVar);
            //根据地块编号获取颜色值
            let color = this.gisScheme.colorInfo[lotNumber];
            color = '#ffcc1b'
            // let aa = this.menubarActive==='3'? 0.6 : 0.85;
            let srcColorObj = {
                r: parseInt('0x' + color.slice(1, 3)),
                g: parseInt('0x' + color.slice(3, 5)),
                b: parseInt('0x' + color.slice(5, 7)),
                a: 1
            }
            
            lotPolygonLayer.geojson.features[lastFeatureId].properties['BLK'] = lotPolygonLayer.geojson.features[lastFeatureId].properties['BLK'] + '.';  
            let red = srcColorObj.r;
            let green = srcColorObj.g;
            let blue = srcColorObj.b;
            let alpha = srcColorObj.a;
            let srcColor = `rgba(${red},${green},${blue},${alpha})`;
            let tempColor = `rgba(${red},${green},${blue},${alpha * 0.8})`;
            let count = 0;

            let len = lotPolygonLayer.paint["fill-color"].length; //lotPolygonLayer.paint["fill-color"].indexOf(lotNumber)
            myInterVar = setInterval(() => {
                count++;
                if (count % 2 === 1) {
                    lotPolygonLayer.paint["fill-color"][len - 1] = tempColor;
                } else {
                    lotPolygonLayer.paint["fill-color"][len - 1] = srcColor;
                }
                gisContext.map.getSource(lotPolygonLayer.source).setData(lotPolygonLayer.geojson);
                gisContext.map.setPaintProperty(lotPolygonLayer.id, "fill-color", lotPolygonLayer.paint["fill-color"]);
            }, 400);
        },
        //清除地块呼吸效果
        clearLotTwinkle() {
            if (lastFeatureId >= 0) {
                lotPolygonLayer.geojson.features[lastFeatureId].properties['BLK'] = lotPolygonLayer.geojson.features[lastFeatureId].properties['BLK'].split('.')[0];
                gisContext.map.getSource(lotPolygonLayer.source).setData(lotPolygonLayer.geojson);
                clearInterval(myInterVar);
                lastFeatureId = -1
            }
        },
        //添加功能区文字图层
        // addFunctionTextLayer() {
            // let div=document.createElement('div')
            // div.innerText='飞行区'
            // div.style.fontSize = "18px";
            // div.style.textShadow = '#000 1px 0 0, #000 0 1px 0, #000 -1px 0 0, #000 0 -1px 0';
            // gisContext.defaultMarkerLayer.addMarker('custom',div,[4.557694515004158,  2.3247998205549862])
        // },
        //显示市政管线
        addPipeline() {
            //修改文字颜色
            lotTextLayer.setLayerProperty('text-color', 'rgb(255,255,255)')
            this.showLayer('pipelinePolyline', true)
        },
        //市政管线筛选
        filterPipeline(pipelineColors) {
            if(!pipeLineLayer) {
                return;
            }
            for(let key in pipelineColors) {
                if(!pipelineColors[key]) {
                    pipelineColors[key] = 'rgba(7, 17, 41, 0.5)'
                }
            }
            let sheme = {
                field: 'Layer',
                colorInfo: pipelineColors
            }
            pipeLineLayer.changeColorByScheme(sheme);
        },
        //删除市政管线
        removePipeline() {
            lotTextLayer.setLayerProperty('text-color', 'rgb(0,0,0)');
            this.showLayer('pipelinePolyline', false)
        },
        //添加地域归属
        addRegionLine() {
            gisContext.layerManager.addMapboxPolylineLayer({ id: 'planPolyline', shpUrl: ShpUrl+'/规划范围.shp', paint: { 'line-color':   [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'rgb(153,204,255)',
                    'rgb(255,0,0)'
                ] } }, false).then((
                )=>{
                // gisContext.map.setPaintProperty('planPolyline','line-dasharray',[2,10])
                gisContext.map.loadImage('./gis/red.png',(err,image)=>{gisContext.map.addImage('redLine',image);
                gisContext.map.setPaintProperty('planPolyline','line-pattern','redLine')})
            });
            
            gisContext.layerManager.addMapboxPolylineLayer({ id: 'limitPolyline', shpUrl: ShpUrl+'/省界线.shp', paint: { 'line-color':   [
                    'case',
                    ['boolean', ['feature-state', 'hover'], false],
                    'rgb(153,204,255)',
                    'rgb(255,255,255)'
                ] } }, false).then(()=>{
                gisContext.map.loadImage('./gis/white.png',(err,image)=>{gisContext.map.addImage('whiteLine',image);
                gisContext.map.setPaintProperty('limitPolyline','line-pattern','whiteLine')})
            });

            gisContext.layerManager.addMapboxTextLayer({ id: 'regionText', shpUrl: ShpUrl+'/shengjie_point.shp', textField: 'name', paint:{'text-color':'rgb(255,255,255)'}, layout:{'text-size':16} }, false)
        },
        //删除地域归属
        removeRegionLine() {
            gisContext.map.removeImage('redLine')
            gisContext.map.removeImage('whiteLine')
            gisContext.layerManager.removeLayer('regionText')
            gisContext.layerManager.removeLayer('planPolyline');
            gisContext.layerManager.removeLayer('limitPolyline');
        },
        //添加bim模型
        renderBim() {
            let _this = this
            let markerMap = new Map()
            
            //指定渲染DOM
            gisContext.BIMDom = document.querySelector('.gisDom')
            gisContext.getProjectLayerInfo('8519e0be-03b3-4d9a-b3da-50c9a2f28a84').then((result) =>{

                console.log(result)
                gisContext.layerManager.modelCenterPrior = false;
                gisContext.layerManager.autoLoadModel = true
                gisContext.layerManager.bimLoadZoom = 12.5

                result.BIM.forEach((item) => {
                    if(item.visible) {
                        let params = {
                            modelID: item.modelInfo.param.modelID,
                            projectID: item.modelInfo.param.projectID,
                            versionNO: '',
                            viewID: '',
                            DOM: document.querySelector('#bimContainer')
                        }

                        let model = new window.bim365.BIMModel(params)
                        model.origin = item.modelInfo.origin
                        model.altitude = item.modelInfo.altitude
                        model.rotate = item.modelInfo.rotate
                        model.layerID = item.modelInfo.layerID
                        gisContext.layerManager.addBIMLayer(model)
                        //方便查看 左右BIM图层显示为true
                        gisContext.layerManager.setLayerVisible(item.layerID,true)
                    }
                })

                //自定义模型 
                // let marker = gisContext.defaultMarkerLayer.addScatterPlotMarker([116.41134, 39.51059], '航站楼', model)
                // marker.getElement().id = model.layerID
                // markerMap.set(model.ID,marker)

                //根据基点为模型添加进度标签，默认隐藏
                for (let index = 0; index < gisContext.layerManager.bimModels.length; index++) {
  
                    const model = gisContext.layerManager.bimModels[index];
                    let div = document.createElement('div')

                    div.className = 'loadingio-spinner-spinner-7g3vda77huf'
                    div.innerHTML = `<div class="ldio-658kcf24nny">
                        <p>0%</p>
                        <div id="load">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  width="50px" height="50px"  viewBox="0 0 200 200" xml:space="preserve">
                                <g>
                                    <linearGradient id="right" gradientUnits="userSpaceOnUse" x1="150" y1="20" x2="150" y2="180">
                                        <stop  offset="0" style="stop-color:#4886CD"/>
                                        <stop  offset="1" style="stop-color:#9DBFE4"/><!--蓝到浅蓝渐变-->
                                    </linearGradient>
                                    <path fill="url(#right)" d="M100,0v20c44.1,0,80,35.9,80,80c0,44.1-35.9,80-80,80v20c55.2,0,100-44.8,100-100S155.2,0,100,0z"/><!--右半圆环-->
                                    <linearGradient id="left" gradientUnits="userSpaceOnUse" x1="50" y1="0" x2="50" y2="180">
                                        <stop  offset="0" style="stop-color:#FFFFFF"/>
                                        <stop  offset="1" style="stop-color:#9DBFE4"/><!--浅蓝到白色渐变-->
                                    </linearGradient>
                                    <path fill="url(#left)" d="M20,100c0-44.1,35.9-80,80-80V0C44.8,0,0,44.8,0,100s44.8,100,100,100v-20C55.9,180,20,144.1,20,100z"/><!--左半圆环-->
                                    <circle fill="#4886CD" cx="100" cy="10" r="10"/>
                                </g>
                            </svg>
                        </div>
                        </div>`;

                    let marker = gisContext.defaultMarkerLayer.addMarker('custom', div, model.origin, undefined)
                    div = marker.getElement();
                    div.id = model.params.modelID + '-progress';
                    div.style.display = 'none';

                    // var moveMark=new gisContext.mapboxgl.Marker().setLngLat(model.origin).addTo(gisContext.map);
                    gisContext.layerManager.bimModels.forEach(bimModel => {

                        //模型加载进度事件
                        bimModel.resource.events.updateProgressBar.on('default', (e) => {
                            //设置marker显隐
                            gisContext.defaultMarkerLayer.setMarkerVisible(markerMap.get(bimModel.layerID),false)
                            let progressDiv = document.getElementById(bimModel.resource.mainModel.modelID + '-progress');
                            if (progressDiv != null) {
                                progressDiv.style.display = 'block';
                                progressDiv.children[0].children[0].innerText = e + '%';
                            }

                            let textDiv = document.getElementById(bimModel.resource.mainModel.modelID);
                            if (textDiv != null) {
                                textDiv.style.display = 'none';
                            }

                        })
                        //模型加载完成事件
                        bimModel.resource.events.bim365Readiness.on('default', () => {
                            let progressDiv = document.getElementById(bimModel.resource.mainModel.modelID + '-progress');
                            if (progressDiv != null) {
                                progressDiv.parentNode.removeChild(progressDiv);
                            }
                            // let blink = document.getElementById(bimModel.layerID)
                            // blink.className = `green ${blink.className}`
                            // //设置marker显隐
                            // gisContext.defaultMarkerLayer.setMarkerVisible(markerMap.get(bimModel.layerID),true)

                            if(bimModel.modelBaseInfo.Name === '航站楼') {
                                this.bimloaded = true
                                //监听视角变化
                                gisContext.gisEvents.viewStateChange.on('default', (e)=>{
                                    // console.log(e)
                                    if(e.type === 'move' && e.originalEvent && e.originalEvent.which === 3) {
                                        _this.$parent.changeViewpoint(true)
                                    }
                                    
                                })
                            }
                        })

                    });
                }
            })
        },
        //显示隐藏模型
        changeBimVisible(visible) {
            gisContext.layerManager.bimModels.forEach(bimModel => {
                this.showLayer(bimModel.layerID, visible)
            }
            )
        }
    }
}
</script>
<style scoped>
@import "../../assets/css/digitalgis/mapbox-gl.css";
@import "../../assets/css/digitalgis/index.css";
@import "../../assets/css/digitalgis/gisIndex.css";
.deckcontainer {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.deckcontainer > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.gisDom {
    z-index: -1;
}
.funcText {
    color: green;
    font-size: 40px;
    -webkit-text-stroke: 1px black;
}
#bimContainer{
    width: 100vw;
    height: 100vh;
    visibility: hidden;
    color: rgba(153,204,255,0.9)
}
</style>